/**
 * Formatea un valor numérico como moneda según la configuración regional.
 * @param value - El valor a formatear (número o string)
 * @param currencySymbol - El símbolo de la moneda (por defecto $)
 * @param locale - La configuración regional (por defecto 'en-US')
 * @param decimals - Número de decimales a mostrar (por defecto 2)
 * @returns String formateado con el símbolo de la moneda y formato regional
 */
export const formatCurrency = (
  value: number | string | undefined | null,
  currencySymbol: string | number | boolean = "$",
  locale: string = "en-US",
  decimals: number = 2,
  showPlusSign: boolean = false,
): string => {
  if (value === undefined || value === null || value === "") {
    const formattedNumber = new Intl.NumberFormat(locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(0);
    return `${String(currencySymbol)}${formattedNumber}`;
  }

  const numericValue = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(numericValue)) {
    const formattedNumber = new Intl.NumberFormat(locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(0);
    return `${String(currencySymbol)}${formattedNumber}`;
  }

  const absValue = Math.abs(numericValue);
  const formattedNumber = new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(absValue);

  let signPrefix = "";
  if (numericValue < 0) {
    signPrefix = "- ";
  } else if (showPlusSign && numericValue > 0) {
    signPrefix = "+ ";
  }

  return `${signPrefix}${String(currencySymbol)}${formattedNumber}`;
};

/**
 * Determina la configuración regional basada en el país
 * @param country - Código del país ('US', 'UK', etc.)
 * @returns Configuración regional correspondiente
 */
export const getLocaleByCountry = (country?: string): string => {
  switch (country) {
    case "UK":
    case "GB":
      return "en-GB";
    case "US":
      return "en-US";
    // Añadir más países según sea necesario
    default:
      return "en-US"; // Valor por defecto
  }
};
